export default function setFormat(rawValue, dataFormat, decimals = 0) {
    const value = !isNaN(Number(rawValue)) ? Number(rawValue) : rawValue
    if (!dataFormat || dataFormat === 'numeric') {
        return typeof value === 'number'
            ? value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
            : value
    }
    if (dataFormat === '%') return `${value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}${dataFormat}`
    return `${dataFormat}${value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`
}
